import React from 'react';
import { Menu, X, Phone, Mail, Instagram } from 'lucide-react';
import { agencyInfo } from '../data/mock';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-dark-primary/95 backdrop-blur-md border-b border-white/10">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img 
              src={agencyInfo.logo} 
              alt={agencyInfo.name} 
              className="h-12 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('home')}
              className="text-white hover:text-gold transition-colors duration-300 font-medium"
            >
              Início
            </button>
            <button 
              onClick={() => scrollToSection('sobre')}
              className="text-white hover:text-gold transition-colors duration-300 font-medium"
            >
              Sobre
            </button>
            <button 
              onClick={() => scrollToSection('portfolio')}
              className="text-white hover:text-gold transition-colors duration-300 font-medium"
            >
              Serviços
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="text-white hover:text-gold transition-colors duration-300 font-medium"
            >
              FAQ
            </button>
            <button 
              onClick={() => scrollToSection('contato')}
              className="text-white hover:text-gold transition-colors duration-300 font-medium"
            >
              Contato
            </button>
          </nav>

          {/* Contact Info - Desktop */}
          <div className="hidden lg:flex items-center space-x-4">
            <a 
              href="https://g.page/r/CV71PwTZvBxPEBM/review"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-1.5 text-gold hover:text-gold-dark transition-colors duration-300 group"
              title="Ver avaliações no Google"
            >
              <span className="text-sm font-semibold">5.0</span>
              <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
              </svg>
            </a>
            <div className="w-px h-4 bg-white/20"></div>
            <a 
              href={`tel:${agencyInfo.phone}`}
              className="flex items-center space-x-2 text-white hover:text-gold transition-colors duration-300"
            >
              <Phone className="w-4 h-4" />
              <span className="text-sm">{agencyInfo.phone}</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-white hover:text-gold transition-colors duration-300"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-white/10 pt-4">
            <nav className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('home')}
                className="text-white hover:text-gold transition-colors duration-300 text-left font-medium"
              >
                Início
              </button>
              <button 
                onClick={() => scrollToSection('sobre')}
                className="text-white hover:text-gold transition-colors duration-300 text-left font-medium"
              >
                Sobre
              </button>
              <button 
                onClick={() => scrollToSection('portfolio')}
                className="text-white hover:text-gold transition-colors duration-300 text-left font-medium"
              >
                Serviços
              </button>
              <button 
                onClick={() => scrollToSection('faq')}
                className="text-white hover:text-gold transition-colors duration-300 text-left font-medium"
              >
                FAQ
              </button>
              <button 
                onClick={() => scrollToSection('contato')}
                className="text-white hover:text-gold transition-colors duration-300 text-left font-medium"
              >
                Contato
              </button>
              <div className="flex flex-col space-y-3 pt-4 border-t border-white/10">
                <a 
                  href={`tel:${agencyInfo.phone}`}
                  className="flex items-center space-x-2 text-white hover:text-gold transition-colors duration-300"
                >
                  <Phone className="w-4 h-4" />
                  <span className="text-sm">{agencyInfo.phone}</span>
                </a>
                <a 
                  href={`mailto:${agencyInfo.email}`}
                  className="flex items-center space-x-2 text-white hover:text-gold transition-colors duration-300"
                >
                  <Mail className="w-4 h-4" />
                  <span className="text-sm">{agencyInfo.email}</span>
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
